module.exports = __webpack_public_path__ + "fonts/Graphik-Semibold-Web.64e3f15.woff";